import { Box, Flex, Image, Skeleton, Text } from '@chakra-ui/react';
import MixinitMultipacksNotice from 'app/components/MixinitMultipacksNotice';
import styles from './styles.module.scss';

interface Props {
  labelDetail?: any;
}

const ReleasesInLabel = ({ labelDetail }: Props) => {
  return (
    <>
      <Flex alignItems="center" gridGap="15px" mb="10px">
        <Image
          objectFit="cover"
          className={styles.listItemImage}
          src={labelDetail?.squareImageUrl}
          loading="lazy"
        />
        <Box>
          {labelDetail?.name ? (
            <Text
              style={{
                fontFamily:
                  'Impact, Haettenschweiler, Franklin Gothic Bold, Charcoal, sans-serif',
              }}
              className={styles.content}
            >
              {labelDetail?.name}
            </Text>
          ) : (
            <Skeleton w="200px" h="32px" />
          )}
          <Text
            style={{
              fontFamily: 'Exo, sans-serif',
            }}
            fontWeight={600}
          >
            MULTIPACKS
          </Text>
        </Box>
      </Flex>
      <MixinitMultipacksNotice
        title="Multipacks are on Mixinit"
        description="The latest Crooklyn Clan audio and video edit multipacks are now available on Mixinit instead of CCV4."
      />
    </>
  );
};

export default ReleasesInLabel;
